<!--查看节点-->
<template>
  <div class="recipient-detail-wrap">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/companyRecipientManange' }">节点管理</el-breadcrumb-item>
      <el-breadcrumb-item>查看节点</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="recipient-detail-con">
      <el-form :inline="true" label-width="90px">
        <div class="mt-15">
          <el-form-item label="节点名称" id="auto-0">
            <el-input
              class="input-custom"
              v-model.trim="siteName"
              :maxlength="20"
              placeholder="请输入节点名称"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="140px" id="auto-1">
            <label class="label-custom" slot="label"
              >签收差值提醒
              <i class="iconfont icon_fail1 font-size18 pointer font-f90" @click="effectiveTonErrorMsg = true"></i
            ></label>
            <el-input
              class="input-custom"
              v-model.trim="effectiveTonError"
              :maxlength="10"
              placeholder="请输入"
            ></el-input>
            <el-dialog :visible.sync="effectiveTonErrorMsg" title="提示" custom-class="tip-dialog">
              <p>收单时如实发、实收数量差值超过预设值，则签收时会有强制提醒</p>
              <div slot="footer" class="text-c">
                <el-button type="primary" @click="effectiveTonErrorMsg = false">我知道了</el-button>
              </div>
            </el-dialog>
          </el-form-item>
          <el-form-item label-width="155px" v-if="grossWeightLimitStatus == 1" id="auto-2">
            <label slot="label">签收毛重最大值（吨）</label>
            <el-input
              class="input-custom-short"
              v-model.trim="grossWeightLimit"
              :maxlength="7"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
        <div class="mt-5">
          <el-form-item label="关联地址" id="auto-3">
            <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
              <el-input
                style="width: 564px"
                class="input-custom"
                v-model="siteAddress"
                @click.native="handleSearchAddress"
                :readonly="true"
                placeholder="请选择地址"
              >
                <i
                  v-if="inputIcon == 'close'"
                  @click="handleClearAddress"
                  slot="suffix"
                  class="el-input__icon el-icon-close pointer"
                ></i>
              </el-input>
            </div>
          </el-form-item>
        </div>
        <div v-if="siteRuleParams.length > 0" id="auto-4">
          <el-form-item
            v-for="(item, idx) in siteRuleParams"
            :key="idx"
            :label="item.ruleName"
            :label-width="item.ruleCode === 'add_tare_weight' ? '140px' : '90px'"
          >
            <el-switch
              v-model="item.status"
              class="mr-20 ml-10"
              :active-value="1"
              @change="handleSwitchchange(item)"
              :inactive-value="0"
              :disabled="switchSelected.status && item.ruleCode !== switchSelected.ruleCode"
            >
            </el-switch>
          </el-form-item>
        </div>
      </el-form>
      <el-tabs v-model="activeName">
        <el-tab-pane label="收单员" name="recopient">
          <div class="toolbar-panel">
            <div class="toolbar-row mt-0">
              <div class="toolbar-item">
                <el-button type="primary" size="small" @click="add" id="auto-5">新增收单员</el-button>
              </div>
            </div>
          </div>
          <el-table :data="recopientList" border id="auto-6">
            <el-table-column prop="name" label="收单员" width="400"></el-table-column>
            <el-table-column prop="phone" label="手机号" width="200"></el-table-column>
            <el-table-column prop="onState" label="收单点统计权限" width="200">
              <template v-slot="scope">
                {{ scope.row.onState ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button
                  type="text"
                  :disabled="recopientList.length === 1"
                  class="font-size12"
                  @click="delItem(scope.row, 'recopient', scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="收单规则" name="receiveRule">
          <div class="toolbar-panel">
            <div class="toolbar-row mt-0">
              <div class="toolbar-item">
                <el-button type="primary" size="small" @click="add" id="auto-7">新增规则</el-button>
              </div>
            </div>
          </div>
          <el-table :data="receiveRuleList" border id="auto-8">
            <el-table-column prop="ruleName" label="规则名称" width="400"></el-table-column>
            <el-table-column prop="operationName" label="公式" width="200"></el-table-column>
            <el-table-column label="规则详情" min-width="200">
              <template v-slot="scope">{{ scope.row.constParams | filterConstParams }}</template>
            </el-table-column>
            <el-table-column prop="handle" label="操作" width="90">
              <template v-slot="scope">
                <el-button
                  :disabled="receiveRuleList.length === 1"
                  type="text"
                  class="font-size12"
                  @click="delItem(scope.row, 'receiveRule', scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="mt-10">
        <el-button type="primary" @click="saveAll" id="auto-9">保存</el-button>
        <el-button @click="save0ff" id="auto-10">取 消</el-button>
      </div>
    </div>
    <!--新增收单员/收单规则-->
    <el-dialog :title="activeName === 'recopient' ? '新增收单员' : '新增收单规则'" :visible.sync="dialogFormVisible">
      <div v-if="activeName === 'recopient'">
        <div class="font-gray mb-20" style="margin-left: 65px">
          注意：经您确认的收单员账号将用于签收运单，请您仔细核对。
        </div>
        <div>
          <el-form ref="formRecopient" label-width="120px" :inline="true">
            <div>
              <el-form-item label="收单员">
                <el-input v-model.trim="formRecopient.name" :maxlength="10" placeholder="请输入收单员"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model.trim="formRecopient.phone" placeholder="请输入手机号">
                  <i slot="suffix" @click="handleIconClick" class="el-input__icon el-icon-search pointer"></i>
                </el-input>
              </el-form-item>
              <div class="mr-10" style="margin-left: 65px">
                <el-checkbox label="" v-model="formRecopient.onState" :true-label="1" :false-label="0"
                  >收单点统计权限</el-checkbox
                >
                <i class="iconfont icon_tip pointer font-blue state-tip-icon" v-popover:popover1></i>
                <el-popover ref="popover1" placement="top-start" width="500" trigger="hover">
                  <p>打开开关后，收单员可以通过收单员端的统计模块，查询及导出该收单点的所有运单</p>
                </el-popover>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <div v-else>
        <el-button class="ml-50 mb-20" type="primary" size="small" @click="addReceiveRule">新增收单规则</el-button>
        <div>
          <el-form ref="formReceiveRule" label-width="120px" :inline="true">
            <div v-for="(item, index) in formReceiveRule" :key="index" class="mb-15">
              <el-form-item label="收单规则">
                <el-select class="width-default" v-model="item.ruleCode" placeholder="请选择">
                  <el-option
                    v-for="subItem in receiveRuleAllList"
                    :disabled="subItem.disabled"
                    :key="subItem.ruleCode"
                    :label="subItem.ruleName"
                    :value="subItem.ruleCode"
                  ></el-option>
                </el-select>
                <el-button
                  class="ml-20"
                  v-if="index !== 0"
                  type="primary"
                  size="small"
                  @click="del('formReceiveRule', index)"
                  >删除</el-button
                >
              </el-form-item>
              <p class="ml-50" v-if="item.constParams">收单明细：{{ item.constParams | filterConstParams }}</p>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmForm(activeName)">确 定</el-button>
      </div>
    </el-dialog>
    <!--选择收单员-->
    <el-dialog title="选择收单员" :visible.sync="dialogRecopientVisible" width="70%">
      <el-table
        height="500"
        ref="singleTable"
        border
        highlight-current-row
        :data="addressList"
        @current-change="handleCurrentChange"
      >
        <el-table-column prop="contactsName" label="收单员"></el-table-column>
        <el-table-column prop="contactsTel" label="手机号"></el-table-column>
      </el-table>
    </el-dialog>
    <!--选择常用地址-->
    <el-dialog title="选择地址" :visible.sync="dialogSiteSelectVisible">
      <el-table height="500" :data="addressList" border>
        <el-table-column prop="addressName" label="常用地址名称"></el-table-column>
        <el-table-column prop="addressDetail" label="详细地址"></el-table-column>
        <el-table-column label="联系人">
          <template v-slot="scope">{{ scope.row.contactsName }} {{ scope.row.contactsTel }} </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <el-button type="primary" class="font-size12" @click="handleUseAddress(scope.row)">使用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:10
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import { isNumber, isRangeNumber, isPhone } from '@fe/validator';

export default {
  data() {
    return {
      inputIcon: '',
      siteName: '',
      siteAddress: '', // 节点地址
      latitude: 0,
      longitude: 0,
      relAddressName: '',
      siteCode: null,
      activeName: 'recopient',
      recopientList: [], // 本节点收单员list
      receiveRuleList: [], // 本节点收单规则list
      receiveRuleAllList: [], // 所有收单规则list
      addressList: [],
      formRecopient: {
        name: '', // 收单员
        phone: '', // 电话
        onState: 0
      },
      formReceiveRule: [
        // 待添加收单规则list
        {
          ruleName: '', //规则名称
          ruleCode: '', // 规则code
          operationName: '', // 公式
          constParams: null // 规则详情
        }
      ],
      formReceiveRuleSubmit: [], // 最终提交收单规则list
      currentRow: null, // 待新增收单员
      dialogFormVisible: false,
      dialogRecopientVisible: false,
      tableClickStatus: false, // 表格选中状态，默认为false，为true时代表手动选中
      effectiveTonError: 200, // 签收差值
      effectiveTonErrorMsg: false,
      dialogSiteSelectVisible: false,
      siteRuleParams: [], // 涨吨抹规则配置
      switchSelected: {
        ruleCode: '',
        status: false
      },
      grossWeightLimit: '', // 毛重上限
      grossWeightLimitStatus: 0 // 毛重上限配置 1:开启0:关闭
    };
  },
  watch: {
    formReceiveRule: {
      handler: function (item) {
        for (let i = 0; i < this.receiveRuleAllList.length; i++) {
          let list = this.receiveRuleAllList[i];
          for (let j = 0; j < item.length; j++) {
            let subItem = item[j];
            if (list.ruleCode === subItem.ruleCode) {
              this.receiveRuleAllList[i].disabled = true;
              subItem.ruleName = list.ruleName;
              subItem.operationName = list.operationName;
              subItem.constParams = list.constParams;
              break;
            } else {
              // 每次重新选择后 需要判断当前项是否在已存在receiveRuleList里面,如果是disabled需要置为true 否则置为false
              let flag = false;
              if (this.receiveRuleList && this.receiveRuleList.length > 0) {
                for (let k = 0; k < this.receiveRuleList.length; k++) {
                  if (list.ruleCode !== this.receiveRuleList[k].ruleCode) {
                    continue;
                  } else {
                    flag = true;
                    break;
                  }
                }
              }
              this.receiveRuleAllList[i].disabled = flag;
            }
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.siteCode = this.$route.query.siteCode;
    this.fetchData();
  },
  methods: {
    // 记录当前选择项
    handleSwitchchange(item) {
      this.switchSelected.ruleCode = item.ruleCode;
      this.switchSelected.status = item.status ? true : false;
    },
    /**
     * @author qff
     * @Description  查询所有收单规则列表
     */
    queryReceiveRuleList(callback) {
      axios.post(api.receiveRuleList, {}).then(res => {
        this.receiveRuleAllList = res.data.rules;
        if (callback && typeof callback === 'function') callback(res.data.rules);
      });
    },

    // 根据节点code查询节点详情
    fetchData() {
      axios.post(api.querySignReceiveSiteDetail, { signSiteCode: this.siteCode }).then(res => {
        this.recopientList = res.data.receivePeopleList || [];
        this.receiveRuleList = res.data.coalReceiveRuleList || [];
        this.siteName = res.data.signSiteName;
        this.siteAddress = res.data.siteAddressDetail;
        this.relAddressName = res.data.relAddressName;
        this.latitude = res.data.latitude;
        this.longitude = res.data.longitude;
        this.effectiveTonError = res.data.effectiveTonError === -1 ? '' : res.data.effectiveTonError;
        this.grossWeightLimit = res.data.grossWeightLimit ? res.data.grossWeightLimit : '';
        this.grossWeightLimitStatus = res.data.grossWeight;
        this.siteRuleParams = res.data.ruleList;
        this.siteRuleParams.map(item => {
          if (item.status) {
            this.switchSelected.ruleCode = item.ruleCode;
            this.switchSelected.status = item.status;
          }
        });
      });
    },
    // 根据当前添加的收单员与查出来的收单员进行匹配，如果收单员姓名和手机号都匹配，则选中此项
    handelTableSelected() {
      this.tableClickStatus = false;
      for (let i = 0; i < this.addressList.length; i++) {
        if (
          this.addressList[i].contactsName === this.formRecopient.name &&
          this.addressList[i].contactsTel === this.formRecopient.phone
        ) {
          this.tableClickStatus = true;
          this.$refs.singleTable.setCurrentRow(this.addressList[i]);
          this.tableClickStatus = false;
          break;
        }
      }
    },
    // 外层新增收单员or收单规则
    add() {
      this.dialogFormVisible = true;
      if (this.activeName === 'recopient') {
        // 每次重新添加收单员需判断currentRow是否有选择值，如果有则清空
        this.formRecopient = { name: '', phone: '', onState: 0 };
        if (this.currentRow && this.currentRow.contactsName) {
          this.$refs.singleTable.setCurrentRow();
        }
      } else {
        this.formReceiveRule = [{ ruleName: '', ruleCode: '', operationName: '', constParams: null }];
        // 每次打开弹框前 根据已选的规则过滤 设置为false
        this.queryReceiveRuleList(ruleList => {
          if (!this.receiveRuleList || this.receiveRuleList.length === 0) return;
          for (let i = 0; i < ruleList.length; i++) {
            for (let j = 0; j < this.receiveRuleList.length; j++) {
              if (this.receiveRuleList[j].ruleCode === ruleList[i].ruleCode) {
                this.receiveRuleAllList[i].disabled = true;
                break;
              }
            }
          }
        });
      }
    },

    // 查询企业常用地址
    async selectAddressDropdown() {
      let res = await axios.post(api.getAddressList, { pageNum: 1, pageSize: 500 });
      this.addressList = res.data.data || [];
    },
    // 触发选择收单员弹层
    async handleIconClick() {
      await this.selectAddressDropdown();
      this.$nextTick(() => {
        this.handelTableSelected();
      });
      this.dialogRecopientVisible = true;
    },
    // 节点名称 选择常用地址
    async handleSearchAddress() {
      await this.selectAddressDropdown();
      this.dialogSiteSelectVisible = true;
    },
    // 节点 选择常用地址确认
    handleUseAddress(item) {
      this.siteAddress = item.addressDetail;
      this.latitude = item.latitude;
      this.longitude = item.longitude;
      this.relAddressName = item.addressName;
      if (this.siteName === '') this.siteName = item.addressName;
      this.dialogSiteSelectVisible = false;
    },
    handleClearAddress(e) {
      this.siteAddress = '';
      this.latitude = 0;
      this.longitude = 0;
      e.stopPropagation();
    },
    mouseEnter() {
      if (this.siteAddress != '') {
        this.inputIcon = 'close';
      }
    },
    mouseLeave() {
      this.inputIcon = '';
    },
    // 选择收单员后赋值
    handleCurrentChange(val) {
      if (!val) return;
      this.currentRow = val;
      this.formRecopient.name = val.contactsName;
      this.formRecopient.phone = val.contactsTel;
      this.dialogRecopientVisible = this.tableClickStatus;
    },
    // 弹层内保存新增收单员和收单规则数据，新增收单员需要调保存接口，新增收单规则值进行页面上的添加显示
    confirmForm(activeName) {
      if (activeName === 'recopient') {
        if (!this.validRecopient()) return;
        this.recipientAdd();
      } else {
        if (!this.validReceiveRule()) return;
        if (this.receiveRuleList && this.receiveRuleList.length > 0) {
          this.receiveRuleList = [...this.receiveRuleList, ...this.formReceiveRule];
        } else {
          this.receiveRuleList = [...this.formReceiveRule];
        }
        this.dialogFormVisible = false;
      }
    },
    // 添加收单规则验证
    validReceiveRule() {
      let validStatus = true;
      for (let i = 0; i < this.formReceiveRule.length; i++) {
        let item = this.formReceiveRule[i];
        for (let key in item) {
          // 某些收单公式可能没有收单明细，故需要排除constParams
          if (key !== 'constParams' && (item[key] === null || item[key] === '')) {
            validStatus = false;
            this.$message.error('请完善收单规则信息后重试');
            return false;
          }
        }
        if (!validStatus) return;
        this.formReceiveRuleSubmit[i] = item.ruleCode;
      }
      return validStatus;
    },
    // 添加收单员验证
    validRecopient() {
      if (!this.formRecopient.name) {
        this.$message.error('收单员姓名不能为空');
        return false;
      }
      if (!this.formRecopient.phone) {
        this.$message.error('收单员手机号不能为空');
        return false;
      }
      if (!isPhone(this.formRecopient.phone)) {
        this.$message.error('手机号格式不正确');
        return false;
      }
      return true;
    },

    // 添加收单员保存
    async recipientAdd() {
      await axios.post(api.createReceivePeople, { ...this.formRecopient, siteCode: this.siteCode });
      this.fetchData();
      this.dialogFormVisible = false;
    },
    // 弹层内新增收单规则
    addReceiveRule() {
      this.formReceiveRule.push({ ruleName: '', ruleCode: '', operationName: '', constParams: null });
    },
    // 弹层内删除待添加的收单规则
    del(nowData, _index) {
      // 收单员 删除了一项 需对receiveRuleAllList匹配当前项重置disabled
      for (let i = 0; i < this.receiveRuleAllList.length; i++) {
        if (this.receiveRuleAllList[i].ruleCode === this[nowData][_index].ruleCode) {
          this.receiveRuleAllList[i].disabled = false;
          break;
        }
      }
      this.formReceiveRule.splice(_index, 1);
    },
    // 删除收单员
    async recipientDel(item) {
      await axios.post(api.deleteReceivePeople, { signPeopleCode: item.recipientCode });
      this.$message.success('删除成功');
      this.fetchData();
    },
    // 删除该节点下的收单员or收单规则，删除收单员调接口，删除收单规则 只进行前端数据删除处理不调接口
    delItem(item, type, _index) {
      if (type === 'recopient') {
        this.$confirm('是否删除该收单员?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.recipientDel(item);
          })
          .catch(() => {});
      } else {
        this.receiveRuleList.splice(_index, 1);
      }
    },
    // 添加最终数据保存
    async saveAll() {
      if (!this.valid()) return;
      let rules = this.siteRuleParams.map(item => {
        return {
          id: item.id,
          ruleCode: item.ruleCode,
          ruleName: item.ruleName,
          status: item.status
        };
      });
      let postData = {
        siteName: this.siteName,
        siteCode: this.siteCode,
        siteAddress: this.siteAddress,
        latitude: this.latitude,
        longitude: this.longitude,
        effectiveTonError: this.effectiveTonError === '' ? -1 : +this.effectiveTonError,
        grossWeightLimit: this.grossWeightLimitStatus ? this.grossWeightLimit : '',
        rules: rules,
        lineRules: this.formReceiveRuleSubmit || [],
        relAddressName: this.siteAddress ? this.relAddressName : ''
      };

      await axios.post(api.addOrUpdateSignSite, postData);
      this.$message.success('修改成功');
      this.$router.push({ path: '/companyRecipientManange' });
    },
    // 最终保存验证
    valid() {
      this.formReceiveRuleSubmit = [];
      let validStatus = true;
      if (!this.siteName) {
        validStatus = false;
        this.$message.error('节点名称不能为空');
        return;
      }
      if (
        this.effectiveTonError &&
        (!isNumber(this.effectiveTonError, true, 4) || !isRangeNumber(this.effectiveTonError, 0, 100000, true, false))
      ) {
        validStatus = false;
        this.$message.error('签收差值不能超过99999，请重新设置');
        return;
      }
      if (
        this.grossWeightLimit &&
        (!isNumber(this.grossWeightLimit, false, 2) || !isRangeNumber(this.grossWeightLimit, 0, 10000, false, false))
      ) {
        validStatus = false;
        this.$message.error('签收毛重格式不正确，请重新设置');
        return;
      }
      if (this.receiveRuleList.length === 0) {
        validStatus = false;
        this.$message.error('请完善收单规则信息后重试');
        return;
      }

      for (let i = 0; i < this.receiveRuleList.length; i++) {
        let item = this.receiveRuleList[i];
        if (!item.ruleCode) {
          validStatus = false;
          this.$message.error('请完善收单规则信息后重试');
          return;
        }
        if (!validStatus) return;
        this.formReceiveRuleSubmit[i] = item.ruleCode;
      }
      return validStatus;
    },
    save0ff() {
      this.$router.go(-1);
    }
  },
  filters: {
    filterConstParams(constParams) {
      if (!constParams) return;
      let str = '';
      constParams.forEach((val, inx) => {
        let dot = inx !== constParams.length - 1 ? ' , ' : '';
        if (val.inputType !== 2) {
          // inputType:1表示文本框，2表示下拉框
          let valNow = val.value;
          if (val.valueType === 2) {
            valNow = val.value;
          }
          str += val.name + '：' + valNow + val.valueUnit + dot;
        } else {
          if (val.valueData) {
            let parseIntVal = parseInt(val.value);
            for (let key in val.valueData) {
              if (val.valueData[key] == parseIntVal) {
                str += val.name + '：' + key + dot;
              }
            }
          }
        }
      });
      return str;
    }
  }
};
</script>
<style lang="postcss">
.recipient-detail-wrap {
  .recipient-detail-con {
    background: #fff;
    padding: 15px;
  }
  .recipient-detail-wrap .label-custom {
    display: inline-block;
    width: 105px;
    text-align: right;
  }
  .recipient-detail-wrap .iconfont-ticket {
    width: 24px;
    color: #11ab19;
    cursor: pointer;
  }
  .recipient-detail-wrap .input-custom {
    margin: 0 0 0 10px;
    width: 200px;
  }
  .recipient-detail-wrap .el-form-item {
    margin-bottom: 10px !important;
  }
  .state-tip-icon {
    font-size: 24px;
    vertical-align: middle;
  }
}
</style>
